// extracted by mini-css-extract-plugin
export default {"imageWrapper":"_K-z","twoColumnImage":"aL-z"};